module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/2-4e27865fc24ca50fddcd832aad18c92e.jpg";